export enum ESituacao {
  ABERTO = 'A',
  FECHADO = 'F'
}
